import { render, staticRenderFns } from "./PlayNavItem.vue?vue&type=template&id=b6b7cac2&scoped=true"
import script from "./PlayNavItem.vue?vue&type=script&lang=js"
export * from "./PlayNavItem.vue?vue&type=script&lang=js"
import style0 from "./PlayNavItem.vue?vue&type=style&index=0&id=b6b7cac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b7cac2",
  null
  
)

export default component.exports